import PaymentButton from './PaymentButton';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import withCountry from '../../../hocs/withCountry';
import { trackPaymentButtonClick } from '../../../../analytics/category/checkout';

const enhance = compose(
  withCountry,
  withHandlers({
    handlePaymentSubmission: props => async (submitPaymentFunc) => {
      props.setSubmittingMethod(props.method);
      trackPaymentButtonClick(props.method);
      try {
        return await submitPaymentFunc();
      } catch (error) {
        props.setSubmittingMethod(null);
      }
    },
  }),
);

export default enhance(PaymentButton);



// WEBPACK FOOTER //
// ./src/client/js/view/components/PaymentMethods/PaymentButton/index.js